import React from "react";
import { Redirect } from "react-router-dom";
import imagen from "../components/generalComponents/images/logoBPW.png";
import NavbarBpw from "../components/generalComponents/NavbarBpw";

const SuperAdministrator = () => {
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);
	return (
		<div>
			{localUser.type === "1" ? (
				<div>
					<NavbarBpw />
					<div className="containerIcon">
						<h2>B I E N V E N I D O</h2>
						<br />
						<br />
						<br />
						<img src={imagen} />
					</div>
				</div>
			) : (
				<Redirect to="/intruso" />
			)}
		</div>
	);
};

export default SuperAdministrator;
